export const SelectTravelersList = [
  {
    id: 1,
    title: 'Just Me',
    desc: 'A sole traveler in exploration',
    icon: '🚶',
    people: '1',
  },
  {
    id: 2,
    title: 'Couple',
    desc: 'Two travelers in tandem',
    icon: '🥂',
    people: '2',
  },
  {
    id: 3,
    title: 'Family',
    desc: 'A group of fun',
    icon: '🏡',
    people: '3',
  },
  {
    id: 4,
    title: 'Friends',
    desc: 'More friends more fun',
    icon: '🥳',
    people: '5',
  },
];

export const SelectBudgetOptions = [
  {
    id: 1,
    title: 'Cheap',
    desc: 'Conscious of costs',
    icon: '💵',
  },
  {
    id: 2,
    title: 'Moderate',
    desc: 'Average',
    icon: '💰',
  },
  {
    id: 3,
    title: 'Luxurious',
    desc: 'I want the best of best',
    icon: '🤑',
  },
];

export const AI_PROMPT = 'Generate Travel Plan for Location : {location}, '
    + 'for {numDays} days for {traveler} people with a {budget} budget, '
    + 'and they like to travel with {transport} and they prefer {food}, '
    + 'and they like to live in a {lodging}. '
    + 'Give me a lodging options list according to their preference with '
    + 'LodgeName, Lodge address, Price, Lodge image url, geo coordinates, rating, '
    + 'descriptions and suggest itinerary with placeName, placeDetails, placeImageUrl, '
    + 'geoCoordinates, ticketPricing, recommendedWayOfTraveling based on their preference, '
    + 'bestTimeToVisit, for {numDays} days with each day plan. '
    + 'All in JSON format with no other stuff or notes or anything, Make entry names are in '
    + 'camelCase with no space in between words in entry names'
    + 'Notes: please return just JSON and make sure you check that commas are properly placed '
    + 'and there are proper indentions in json format. Do not include "`" at the beginning or end of the response.';
